import { transparentize } from 'polished'
import styled from 'styled-components'

import { ButtonPlain } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	isOpen: boolean
}

export const Header = styled(ButtonPlain)<Props>`
	display: flex;
	padding: ${helpers.spacing.medium};
	column-gap: ${helpers.spacing.medium};
	align-items: center;
	background-color: transparent;
	transition: background-color 150ms ${helpers.animation.default};
	border-radius: ${({ theme, isOpen }) => (isOpen ? `${theme.borderRadius} ${theme.borderRadius} 0 0` : theme.borderRadius)};
	width: 100%;

	&:hover:not(:disabled) {
		background-color: ${({ theme }) => transparentize(0.85, theme.color.actionHover)};
	}
`
